exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "  .loader {\r\n            border: 8px solid hsl(36, 95%, 49%); /* Light grey */\r\n            border-top: 8px solid white; /* Blue */\r\n            border-radius: 50%;\r\n            width: 40px;\r\n            height: 40px;\r\n            -webkit-animation: spin 1s linear infinite;\r\n                    animation: spin 1s linear infinite;\r\n        }\r\n\r\n       @-webkit-keyframes spin {\r\n          0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); }\r\n         100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); }\r\n       }\r\n\r\n       @keyframes spin {\r\n          0% { -webkit-transform: rotate(0deg); transform: rotate(0deg); }\r\n         100% { -webkit-transform: rotate(360deg); transform: rotate(360deg); }\r\n       }\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/login/login/login.component.css
// module id = ../../../../../src/app/login/login/login.component.css
// module chunks = main